module.exports = __webpack_public_path__ + "static/media/introduction1.d0e6f859.webp";